import '../App.css';
import React,  {Alert,Component,PointerEvent} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade,EffectCreative } from 'swiper';
import { Pagination, Navigation,Autoplay } from "swiper";
import { useRef, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import "swiper/css/effect-creative";
import { Nav,Navbar,Form,Button,Container,Row,Col,NavDropdown,Card,Modal} from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import MailIcon from '@material-ui/icons/Mail';
import CallIcon from '@material-ui/icons/Call';
import HouseIcon from '@material-ui/icons/House';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { BrowserRouter as Router, Switch, Route, Link,Redirect,HashRouter } from 'react-router-dom';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Carousel from 'react-bootstrap/Carousel';
import { BrowserView, MobileView, isBrowser, isMobile} from "react-device-detect";
import queryString from 'query-string';
import { Rating } from 'react-simple-star-rating'
import VideoBackground from './Videobackground';
import ReactPlayer from 'react-player';
import loader_exotic from './loader_exotic.svg';
import logo_exotic from './logo_exotic_400.png';
import About_us from './About_us.png';
import Alle_baobab     from './Alle_baobab.png';
import Core_Service     from './Core_Service.png';
import ATTAMember_opt2 from './ATTAMember_opt2.jpeg';
import ATTAMember_opt3 from './ATTAMember_opt3.jpeg';
import Aboutus_baobab from './About_us_baobab.png';
import Aboutus_tsingy from './About_us_tsingy.png';
import Aboutus_lemurien from './About_us_lemurien.png';
import Aboutus_service from './About_us_service.png';

const idvideoexotic = "xTe4j7126l4";

class Aboutus extends Component{
    
  constructor(props) {
  super(props);
    this.state = {
      loaddata : true,
      show: false,
      setShow: false,
      isModalVisible: false,
      isModalloderVisible : true,
      accueiltitre: '',
      accueilimage: '',
      touteslesarticles: [],
      touteslestours: [],
      listimage:[],
      idtourselect:0,
      title:'',
      description:'',
      roadmap:'',
      extensionfile:'',
      touteslesaccueil: [],
      touteslesgallery: [],
      gallery: [],
      allopinionuser:[],
      width: 0,
      height: 0,
      scrollpage:0,
      ratingvalue:5,
      ismodalinscription:false,
      avisdescription:'',
      screennwidth:0,
      screenheight:0,
      isLoadingmovie: true
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      
  }
  
  async componentDidMount() {

    
      this.setState({
        screennwidth:window.innerWidth-16,
        screenheight:window.innerHeight,
      })
    
      document.title = "About us"
    
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.updateWindowDimensions);
      
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight, scrollpage: window.scrollY });
  }

  scrolltop(){
    window.scrollTo(0, 0)
  }

  handleLoaded = () => {
    this.setState({ isLoadingmovie: false });
  };

  refreshgallery(datagallery){
    
    datagallery.forEach((item)=>{
      this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage, thumbnail: process.env.PUBLIC_URL + './images/gallery/' + item.idgallery + '.' + item.extensionimage});
    })

    /*for (let i = 1; i < 21; i++) {

      if(i<10){
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/0' + i + '.jpg'});
      }else{
        this.state.gallery.push({ original: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg', thumbnail: process.env.PUBLIC_URL + './images/gallerie/' + i + '.jpg'});
      }
      
    }*/

  }

  reservation = (typetours) => { 

    window.location.href = "mailto:contact@exotic-madagascar.mg?Subject=Booking to " + typetours

  }

  async selecttours(idtours,tourstitle,toursdescription,toursroadmap,extensionfile){

    this.setState({
      idtourselect: idtours,
      title:tourstitle,
      description:toursdescription,
      roadmap:toursroadmap,
      extensionimg: extensionfile,
      isModalVisible:true
    })
  
    const response = await fetch('https://exotic-madagascar.com/wbs/tours/gallerytours/selectimagetours.php',{                  
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({
            idtrs:idtours
          })});
    const data = await response.json();
  
    this.setState({
      listimage:data,
    })
  
  }

  addopinion(){

    if(this.state.nom.length == 0 && this.state.prenoms.length == 0) {

      alert("Please add your name or lastname.");
            
      return;

    }

    if (typeof(this.state.mail) == 'undefined') {

      alert("Please add your mail address.");
            
      return;

    }

    if (typeof(this.state.mail) !== undefined) {

        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!pattern.test(this.state.mail)) {

            alert("Please write an exact mail address.");
            
            return;

        }
          
    }

    if(this.state.motdepasse.length < 8) {

      alert("Password must be minimum 8 characters.");
            
      return;

    }

    if(this.state.avisdescription.length == 0) {

      alert("Please add your rating description.");
            
      return;

    }

    fetch(`https://exotic-madagascar.com/wbs/users/addopinion.php`,{                  
            
          method:'post',
          headers: {'Content-Type':'application/x-www-form-urlencoded'},
          body: queryString.stringify({

            Nom: this.state.nom,
            Prenoms: this.state.prenoms,
            Email:this.state.mail,
            Motdepasse:this.state.motdepasse,
            avis : this.state.ratingvalue,
            descriptionavis : this.state.avisdescription,

          })

      })

      .then(response => response.json())
      .then(data => {

        if(JSON.stringify(data).replace(/\"/g, "") === 'User exist'){
          this.setState({ errorform: true, errormessage: 'User is exist.' });

          return;

        }

        if(JSON.stringify(data).replace(/\"/g, "") === 'Error insert'){
          this.setState({ errorform: true, errormessage: 'Error on server. Please repeat again.' });

          return;

        }

    
        if(JSON.stringify(data).replace(/\"/g, "") !== '0'){
          
          this.setState({ allopinionuser: data})
          
          this.setState({
            errorform: false,
            errormessage:'',
            nom:'',
            prenoms:'',
            mail:'',
            motdepasse:'',
            avis : "",
            ratingvalue:5,
            descriptionavis : "",
            avisdescription : "",
            ismodalinscription:false,
            //signin : true,
          });   
          
         
          alert("Your registration has been completed add your opinion has been add. You can log in to edit your profil.");

        }            
                  
      })

      .catch(error => {
            alert(error);
            this.setState({ tokenuser: error});
      });  

  }
  

  handlePointerMove = (value, index) => {
    this.setState({ ratingvalue: value}) 
  }

  render() {

      const onPointerMove = (value,index) => this.handlePointerMove(value, index)

        return (
            
                <div>
                
               

                  {/*
                  <div className="d-flex align-items-center justify-content-center">
                      <img src={logo_exotic} alt="Exotic Madagascar"  style={{width:"400px", height:"400px", marginTop:"100px"}}/>
                  </div>
                  */}

                  <div className='align-items-center'>                         
                      <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'100px'}}>About us</p>
                  </div>
                
                  <BrowserView>

                    <div style={{width:"100%"}}>
                        <img src={Aboutus_baobab} alt="Exotic Madagascar"  className="float-end me-4 mb-4 rounded shadow" style={{ width: '48%', height:"60vh", padding:"20px", margin:"30px" }}/>
                        <div >
                          <p style={{fontSize:"34px", padding:"20px"}}>
                            <span>Madagascar, an exceptional island, reveals a mosaic of unique landscapes and captivating destinations, where wild nature, rich culture, and authenticity come together to offer an extraordinary travel experience.<br/> Exotic Madagascar DMC is a specialized boutique destination management company that provides high-end, bespoke travel solutions across the "Big Island". Known for its elite logistics and 24/7 expert service, the agency focuses on delivering authentic, luxury experiences tailored to the unique needs of its global clientele.</span>

                          </p>
                        </div>
                        
                      </div>

                

                  </BrowserView>

                  <MobileView>

                    <div className="d-flex flex-column align-items-center justify-content-center" style={{marginTop:"-60px"}}>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%", padding:"10px"}}>
                          <img src={Aboutus_baobab} alt="Exotic Madagascar" className="float-start me-4 mb-4 rounded shadow" style={{width:"100%", height:"250px", padding:"20px", margin:"30px"}}/>
                        </div>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%", marginTop:"-20px"}}>
                          <p style={{fontSize:"20px", padding:"10px"}}>Madagascar, an exceptional island, reveals a mosaic of unique landscapes and captivating destinations, where wild nature, rich culture, and authenticity come together to offer an extraordinary travel experience.<br/> Exotic Madagascar DMC is a specialized boutique destination management company that provides high-end, bespoke travel solutions across the "Big Island". Known for its elite logistics and 24/7 expert service, the agency focuses on delivering authentic, luxury experiences tailored to the unique needs of its global clientele.</p>
                        </div>
                        
                    </div>

                    
                  </MobileView>

                <div>

                <div style={{ clear: "both" }}>

                  <div className='align-items-center' >                         
                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'40px'}}>Core Service Specializations</p>
                  </div>
                
                  <BrowserView>
   
                        <div style={{width:"100%"}}>
                          <img src={Aboutus_service} alt="Exotic Madagascar"  className="float-start me-4 mb-4 rounded shadow" style={{ width: '48%', height:"60vh", padding:"20px", margin:"30px" }}/>
                          <div >
                          <p style={{fontSize:"34px", padding:"20px"}}>
                            <span>High-End & Luxury Services: The agency excels in "ultra-luxury" to "premium standard" tours, utilizing private plane charters and exclusive helicopter transfers to bypass Madagascar's challenging road infrastructure.</span><br/>
                            <span>Free Independent Travelers (FIT): For individual travelers, Exotic Madagascar designs personalized itineraries that range from intimate wildlife expeditions in national parks like Andasibe to secluded beach retreats on islands like Anjanjavy, Miavana Nosy Be.</span><br/>
                            <span>Groups & Special Interests: They manage complex group logistics, oﬀering professional multi-lingual guides (ﬂuent in English, French, and others) and a ﬂeet of high-quality oﬀ-road vehicles to ensure safety and comfort for larger parties.</span><br/>
                            <span>MICE (Meetings, Incentives, Conferences, Events): Exotic Madagascar provides comprehensive MICE support, including venue selection at luxury resorts, coordination of domestic ﬂights, and the creation of unique incentive programs such as private cruises on the Pangalanes Canal.</span><br/>
                          </p>
                          </div>
                        </div>

                  </BrowserView>

                  <MobileView>

                    <div className="d-flex flex-column align-items-center justify-content-center" style={{marginTop:"-50px"}}>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%", padding:"10px"}}>
                          <img src={Aboutus_service} alt="Exotic Madagascar" className="float-start me-4 mb-4 rounded shadow" style={{width:"100%", height:"250px", padding:"20px", margin:"30px"}}/>
                        </div>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%",marginTop:"-20px"}}>
                          <p style={{fontSize:"20px", padding:"20px"}}>
                            <span>High-End & Luxury Services: The agency excels in "ultra-luxury" to "premium standard" tours, utilizing private plane charters and exclusive helicopter transfers to bypass Madagascar's challenging road infrastructure.</span><br/>
                            <span>Free Independent Travelers (FIT): For individual travelers, Exotic Madagascar designs personalized itineraries that range from intimate wildlife expeditions in national parks like Andasibe to secluded beach retreats on islands like Anjanjavy, Miavana Nosy Be.</span><br/>
                            <span>Groups & Special Interests: They manage complex group logistics, oﬀering professional multi-lingual guides (ﬂuent in English, French, and others) and a ﬂeet of high-quality oﬀ-road vehicles to ensure safety and comfort for larger parties.</span><br/>
                            <span>MICE (Meetings, Incentives, Conferences, Events): Exotic Madagascar provides comprehensive MICE support, including venue selection at luxury resorts, coordination of domestic ﬂights, and the creation of unique incentive programs such as private cruises on the Pangalanes Canal.</span><br/>
                          </p>
                        </div>
                        
                    </div>

                    
                  </MobileView>

                </div>

                <div style={{ clear: "both" }}>

                  <div className='align-items-center'>                         
                    <p style={{color:"#3498db", fontWeight:"bold", fontSize:"2em", textAlign:'center', paddingTop:'40px'}}>Experiences Provided</p>
                  </div>
                
                  <BrowserView>

                    
                    <div style={{width:"100%"}}>
                      <img src={Aboutus_lemurien} alt="Exotic Madagascar"  className="float-end me-4 mb-4 rounded shadow" style={{ width: '48%', height:"60vh", padding:"20px", margin:"30px" }}/>
                      <div >
                        <p style={{fontSize:"34px", padding:"20px"}}>
                          <span>Wildlife Expeditions: Expert-led encounters with endemic lemurs, chameleons, and rare birds in their natural habitats. </span><br/>
                          <span>Bespoke Landscapes: Guided tours of iconic sites including the Avenue of the Baobabs, the limestone formations of Tsingy de Bemaraha, and the rainforests of the East, Isalo sand stone, and all Madagascar.</span><br/>
                          <span>Leisure & Discovery: Luxury stays at premier boutique hotels and beach resorts, combined with activities like snorkeling, diving, and cultural immersions.</span><br/>
                          <span>Our agency is frequently praised in reviews for its professionalism, meticulous attention to detail, and the ability to handle last-minute customizations for demanding VVIP travelers.</span><br/>
                        </p>
                      </div>
                      
                    </div>
                    
                  
                  </BrowserView>

                  <MobileView>

                    <div className="d-flex flex-column align-items-center justify-content-center" style={{marginTop:"-50px"}}>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%", padding:"10px"}}>
                          <img src={Aboutus_lemurien} alt="Exotic Madagascar" className="float-start me-4 mb-4 rounded shadow" style={{width:"100%", height:"250px", padding:"20px", margin:"30px"}}/>
                        </div>

                        <div className="d-flex align-items-center justify-content-center" style={{width:"100%",marginTop:"-20px"}}>
                          <p style={{fontSize:"20px", padding:"20px"}}>
                            <span>Wildlife Expeditions: Expert-led encounters with endemic lemurs, chameleons, and rare birds in their natural habitats. </span><br/>
                            <span>Bespoke Landscapes: Guided tours of iconic sites including the Avenue of the Baobabs, the limestone formations of Tsingy de Bemaraha, and the rainforests of the East, Isalo sand stone, and all Madagascar.</span><br/>
                            <span>Leisure & Discovery: Luxury stays at premier boutique hotels and beach resorts, combined with activities like snorkeling, diving, and cultural immersions.</span><br/>
                            <span>Our agency is frequently praised in reviews for its professionalism, meticulous attention to detail, and the ability to handle last-minute customizations for demanding VVIP travelers.</span><br/>
                          </p>
                        </div>
                        
                    </div>

                    
                  </MobileView>

                </div>

              
                                        
                   
                </div>

                    
                    {this.state.scrollpage>200 ?

                        <Zoom>
                          <button className="bnttop" onClick={() => this.scrolltop()} style={{width:'50px', height:'50px', marginBottom:"70px",padding:"0%"}}><span><KeyboardDoubleArrowUpIcon /></span></button>
                        </Zoom>

                        :

                        null
                    
                    }

                      {this.state.ismodalinscription == true?
                      
                          <Modal
                          
                            show={this.state.ismodalinscription}
                            onHide={ () => this.setState({ismodalinscription:false, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})}
                            dialogClassName="modal-dialog"
                            aria-labelledby="example-custom-modal-styling-title" centered
                            >
      
                          <Modal.Body>
                                      
                                                    
                          <div style={{marginRight:"10px"}}>
      
                            <BrowserView>
      
                            <Container>
                              <Row>
                                <Col>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Last name</label>
                                    <input type="text" className="form-control" value={this.state.nom} onChange={(e) => this.setState({ nom: e.target.value})} />
                                  </div>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>First name</label>
                                    <input type="text" className="form-control" value={this.state.prenoms} onChange={(e) => this.setState({ prenoms: e.target.value})} />
                                  </div>
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Email *</label>
                                    <input type="email" className="form-control" aria-describedby="emailHelp" value={this.state.mail} onChange={(e) => this.setState({ mail: e.target.value})} />
                                  </div>   
      
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Password *</label>
                                    <input type="password" className="form-control" value={this.state.motdepasse} onChange={(e) => this.setState({ motdepasse: e.target.value})} />
                                  </div>

                                  <div className="form-group" style={{margin:'10px'}}>
                                    <Rating
                                      onPointerMove={onPointerMove}
                                      initialValue={this.state.ratingvalue}
                                    />
                                  </div>
        
                                  <div className="form-group" style={{margin:'10px'}}>
                                    <label>Your opinion</label>
                                    <Form.Control  size="sl" as="textarea" rows={4} placeholder="Your opinion about exotic Madagascar ..." ref="avisdescription" value={this.state.avisdescription} onChange={(e) => this.setState({ avisdescription: e.target.value})} />
                                  </div>
                                
                                </Col>
      
                              
                              </Row>
                            </Container>
      
                            </BrowserView>
      
                            <MobileView>
                                      
                              <div className="form-group" style={{margin:'10px'}}>
                                  <label>Last name</label>
                                  <input type="text" className="form-control" value={this.state.nom} onChange={(e) => this.setState({ nom: e.target.value})} />
                                </div>
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>First name</label>
                                  <input type="text" className="form-control" value={this.state.prenoms} onChange={(e) => this.setState({ prenoms: e.target.value})} />
                                </div>
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Email *</label>
                                  <input type="email" className="form-control" aria-describedby="emailHelp" value={this.state.mail} onChange={(e) => this.setState({ mail: e.target.value})} />
                                </div>   
      
                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Password *</label>
                                  <input type="password" className="form-control" value={this.state.motdepasse} onChange={(e) => this.setState({ motdepasse: e.target.value})} />
                                </div>
                                <div className="form-group" style={{margin:'10px'}}>
                                  <Rating
                                    onPointerMove={onPointerMove}
                                    initialValue={this.state.ratingvalue}
                                  />
                                </div>

                                <div className="form-group" style={{margin:'10px'}}>
                                  <label>Your opinion</label>
                                  <Form.Control  size="sl" as="textarea" rows={4} placeholder="Your opinion about exotic Madagascar ..." ref="avisdescription" value={this.state.avisdescription} onChange={(e) => this.setState({ avisdescription: e.target.value})} />
                                </div>
      
                            </MobileView>
                                                                        
                            <div className="d-flex justify-content-center">
                                <Button className="btn btn-danger"style={{ margin:"10px", width:'150px', marginRight:'50px'}} onClick={ () => this.setState({ismodalinscription:false, nom:"", prenoms:"", mail:"", motdepasse:"",ratingvalue:5,avisdescription:""})} variant="primary">Close</Button>
                                <Button className="btn bntsign" style={{ margin:"10px",right: 0, width:'150px',backgroundColor: "#3498db",border: 0,}} onClick={() => this.addopinion()} >Add opinion</Button>   
                            </div>
      
                            </div>
                            
                          </Modal.Body>
                          </Modal>
      
                        
                          :
      
                          null
      
                        }

                   <BrowserView style={{ clear: "both" }}>

                      <Fade Zoom>
                        <div id="contact" className="justify-content-center footer">

                          <div className="row justify-content-center" style={{paddingTop:"20px"}}>
                            <img src={ATTAMember_opt2} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                            <img src={ATTAMember_opt3} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                          </div>

                          <div className="d-flex flex-row justify-content-center" style={{marginTop:"20px"}}>

                                <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:20}}/></a>

                                <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10}}/></a>

                                <a href="https://www.youtube.com/@Exotic-Madagascar" target="_blank"><YouTubeIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginLeft:20}}/></a>
                          
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginBottom:10, marginRight:20}}/></a>
                              <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <a href="tel:+261340963076" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/>+261 34 09 630 76</a>
                          </div>

                          <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                              <span style={{fontSize:'20px' , color: 'white', marginBottom:20}}>Antananarivo 101</span>
                          </div>

                          <div className="text-center">
                              <div className="py-1">

                                  <p className="textombrenoir" style={{ color:'white',fontSize:"20px"}}>
                                    Copyright {new Date().getFullYear()} Exotic Madagascar. All rights reserved.
                                  </p>
                                                                                    
                              </div>
                          </div>

                      </div>
                    </Fade>

                    </BrowserView>

                     <MobileView>

                        <Fade Zoom>

                          <div id="contact" className="justify-content-center footer">

                            <div className="d-flex flex-column align-items-center justify-content-center" style={{paddingTop:"40px"}}>
                              <img src={ATTAMember_opt2} alt="Exotic Madagascar"  style={{width:"250px", height:"250px"}}/>
                              <img src={ATTAMember_opt3} alt="Exotic Madagascar"  style={{width:"250px", height:"250px", marginTop:"40px"}}/>
                            </div>

                            <div className="d-flex flex-row justify-content-center" style={{marginTop:"20px"}}>

                              <a href="https://facebook.com/ArmelMadagascar" target="_blank"><FacebookIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:20}}/></a>

                              <a href="https://linkedin.com/in/exoticmadagascar" target="_blank"><LinkedInIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10}}/></a>

                              <a href="https://www.youtube.com/@Exotic-Madagascar" target="_blank"><YouTubeIcon style={{fontSize:'40' , color: '#3498db', marginTop:10,marginBottom:10, marginLeft:20}}/></a>
                        
                            </div>

                            <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                                <a href="mailto:contact@exotic-madagascar.com" target="_blank"><MailIcon style={{fontSize:'30' , color: '#3498db', marginBottom:10, marginRight:20}}/></a>
                                <a href="mailto:contact@exotic-madagascar.com" target="_blank">resa@exotic-madagascar.mg</a>
                            </div>

                            <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                                <a href="tel:+261340963076" target="_blank"><CallIcon style={{fontSize:'30' , color: '#3498db', marginTop:10,marginBottom:10, marginRight:10}}/>+261 34 09 630 76</a>
                            </div>

                            <div className="contactlist justify-content-center" style={{marginTop:"20px"}}>  
                                <span style={{fontSize:isBrowser?"20px":"20px" , color: 'white', marginBottom:20}}>Antananarivo 101</span>
                            </div>

                            <div className="text-center">
                                <div className="py-1">

                                    <p className="textombrenoir" style={{ color:'white',fontSize:isBrowser?"20px":"14px"}}>
                                      Copyright {new Date().getFullYear()} Exotic Madagascar. All rights reserved.
                                    </p>
                                                                                      
                                </div>
                            </div>

                          </div>

                      </Fade>

                    </MobileView>
                   

              </div>
        );
      }
  
}

export default Aboutus;
